import { createActionGroup, props } from '@ngrx/store';
import { Entity } from '../../models/entity.model';

export const MessagesActions = createActionGroup({
  source: 'Messages',
  events: {
    set_message_entites: props<{ entities: Entity[] }>()
  }
});
